import axios from "axios";

export const saveTimeOffs = async (payload) => {

    return await axios.post(`api/accrual/update-time-offs/${payload.company}`, payload).catch((e) => { console.log(e) });
};



export const getTimeOffs = async (companyId) => {

    let response = await axios.get(`api/accrual/get-time-offs/${companyId}`);
    return response.data || [];
}